import React, { useEffect, useState } from "react";
import { resourceLimits } from "worker_threads";
import styles from "../dashboard/componentsStyle/regularparentpermit.module.css";
import { ReactComponent as LogoSvg } from '../svg/newlogo.svg';
import { Backdrop, Button, CircularProgress, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';

const TeacherSelectReject: React.FC<any> = (props) => {

    const [id, setId] = useState();
    const [loading, setLoading] = useState(false);
    const [permitState, setPermitState] = useState<any>();
    const [reason, setReason] = useState("");


    useEffect(() => {

    }, []);

    const submit = async () => {

        try {

            if(!reason || reason.trim() === "") {
                alert("코칭 거절 사유를 입력해주세요");
                return;
            }

            setLoading(true);

            const meta = document.createElement("meta");
            meta.name = "viewport";
            meta.content = "width=device-width, initial-scale=1";
            document.getElementsByTagName("head")[0].appendChild(meta);


            const url = window.location.href;
            var query = url.split("?insertId=")[1];

            const id = query.split("&code=")[0];
            const code = query.split("&code=")[1];

            console.log("id", id);
            console.log("code", code);
            console.log("reason", reason);

            if (+code === (4321 * (+id))) {

                fetch(`https://peetsunbae.com/dashboard/mycoach/teacherselect/reject`, {
                    method: "post",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify({
                        id,
                        reason
                    })
                }).then((response: any) => {
                    response.json()
                        .then((result: any) => {

                            setLoading(false);

                            if (result.message === "success") {

                                const isPastWeek = result.isPastWeek;

                                if (isPastWeek) {
                                    setPermitState(2); // 거절
                                } else {
                                    setPermitState(1); // 승인
                                }

                            }

                        })
                })
            }

        } catch (e) {
            console.error(e);
        }

    }

    return (
        <div className={styles.main}>

            {
                (!permitState && !loading) &&
                <div>
                    {/* <div style={{
                        marginBottom : "1rem",
                        fontFamily : "Apple_SB",

                    }}>
                        코칭 거절 사유를 입력해주세요
                    </div> */}
                    <div>
                        <TextField
                            multiline
                            rows={2}
                            fullWidth
                            variant="outlined"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="코칭 거절 사유를 입력해주세요"
                        />
                    </div>
                    <div>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginTop: "1.2rem" }}
                            onClick={submit}
                            fullWidth   
                        >
                            코칭 거절하기
                        </Button>
                    </div>
                </div>
            }


            {
                (permitState && permitState === 1 && !loading) &&
                <div className={styles.text}>
                    학생의 코칭 신청이<br></br><span style={{ color: "red" }}>승인 거절 처리</span> 되었습니다.
                </div>
            }

            {
                (permitState && permitState === 2 && !loading) &&
                <div className={styles.text}>
                    일주일이 지난 내역이라<br></br><span style={{ color: "red" }}>승인 처리가</span>불가능 합니다.
                </div>
            }


            <div className={styles.logoDiv}>
                <LogoSvg className={styles.newlogo} />
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default TeacherSelectReject;